import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import {useTranslation} from "react-i18next";
import Grid from '@mui/material/Grid';
import {observer} from 'mobx-react';
import {action} from 'mobx';
import React from 'react';
import {LOCT_CITY, LOCT_ASSO, LOCT_REG, LOCT_ADDR} from './Locations.js';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {locTypes} from './Locations.js';
import {getCityName} from './Trans.js';
import {COMM_OK} from './WsR2.js';

const LocRegTargetField = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function locRegChanged(event) {
		if (!gStorage.conn.online)
			return;

		gStorage.location.setLocation({...gStorage.location.loc, tgt_id: parseInt(event.target.value, 10)});
	}

	function locGetCityName(id) {
		const c = gStorage.lists.citylist.list.find(c => c.id === id);

		return getCityName(c, gStorage.conn.user);
	}

	function regListSort(r1, r2) {
		const ret = locGetCityName(r1.city_id).localeCompare(locGetCityName(r2.city_id), 'fi');
		if (ret)
			return ret;

		return r1.name.localeCompare(r2.name, 'fi');
	}

	if (gStorage.location.loc.loct_id !== LOCT_REG)
		return null;

	const _rl = [{id: 0, name: '--'}];
	
	const regList = _rl.concat(gStorage.lists.reglist.list.slice().sort(regListSort)).map((r) => {
		const regName = r.id === 0 ? r.name : locGetCityName(r.city_id) + ', ' + r.name;

		return (<MenuItem key={r.id} value={r.id}>{regName}</MenuItem>);
	});

	return (
		<Grid size={{xs: 12}} align={'left'}>
			<FormControl variant="outlined" size="small">
				<InputLabel>{t('add.reg_tgt')}</InputLabel>
				<Select
					value={gStorage.location.loc.tgt_id}
					onChange={locRegChanged}
					style={{width: 300, margin: 8}}>
						{regList}
				</Select>
			</FormControl>
		</Grid>
	);
});

const LocAssoField = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function locAssoChanged(event) {
		if (!gStorage.conn.online)
			return;

		gStorage.location.setLocation({...gStorage.location.loc, tgt_id: parseInt(event.target.value, 10)});
	}

	if (gStorage.location.loc.loct_id !== LOCT_ASSO)
		return null;

	const _al = [{id: 0, name: ''}];

	const assoList = _al.concat(gStorage.lists.assolist.list).map((a) => {
		return (<MenuItem key={a.id} value={a.id}>{a.name}</MenuItem>);
	});

	return (
		<Grid size={{xs: 12}} align={'left'}>
			<FormControl variant="outlined" size="small">
				<InputLabel>{t('locations.club')}</InputLabel>
				<Select
					value={gStorage.location.loc.tgt_id}
					onChange={locAssoChanged}
					style={{width: 300, margin: 8}}>
						{assoList}
				</Select>
			</FormControl>
		</Grid>
	);
});

const LocCitiesField = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function locCityChanged(event, city) {
		if (!gStorage.conn.online)
			return;

		gStorage.location.setLocation({...gStorage.location.loc, cities: event.target.value});
	}

	if (gStorage.location.loc.loct_id !== LOCT_CITY)
		return null;

	function getStyles(id, array) {
		return {
			fontWeight:
				array.indexOf(id) === -1
					? 'normal'
					: 'bold'
			};
	}

	function locGetCityName(city) {
		return getCityName(city, gStorage.conn.user);
	}

	function citySort(c1, c2) {
		return locGetCityName(c1).localeCompare(locGetCityName(c2), 'fi');
	}

	const cityList = gStorage.lists.citylist.list.slice().sort(citySort).map((c) => {
		return (<MenuItem key={c.id} value={c.id} style={getStyles(c.id, gStorage.location.loc.cities)}>{locGetCityName(c)}</MenuItem>);
	});

	return (
		<Grid size={{xs: 12}} align={'left'}>
			<FormControl variant="outlined" size="small">
				<InputLabel>{t('locations.cities')}</InputLabel>
				<Select
					multiple
					value={gStorage.location.loc.cities}
					onChange={locCityChanged}
					style={{width: 300, margin: 8}}>
						{cityList}
				</Select>
			</FormControl>
		</Grid>
	);
});

const LocAddressField = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function locAddrChanged(e) {
		if (!gStorage.conn.online)
			return;

		gStorage.location.loc.address = e.target.value;
		gStorage.location.modified = true;
	}

	function locGetCityName(city) {
		return getCityName(city, gStorage.conn.user);
	}

	function locCityChanged(e) {
		if (!gStorage.conn.online)
			return;

// 		console.log('locCityChanged');
		gStorage.location.setLocation({...gStorage.location.loc, tgt_id: parseInt(e.target.value, 10)});
	}

	function citySort(c1, c2) {
		return locGetCityName(c1).localeCompare(locGetCityName(c2), 'fi');
	}
	
// 	console.log('LocAddressField', gStorage.location.loc.loct_id, LOCT_ADDR, gStorage.location.loc.loct_id !== LOCT_ADDR);

	if (gStorage.location.loc.loct_id !== LOCT_ADDR)
		return null;

	const _cl = [{id: 0, fi: ''}];
	
	const cityList = _cl.concat(gStorage.lists.citylist.list.slice()).sort(citySort).map((c) => {
		return (<MenuItem key={c.id} value={c.id}>{locGetCityName(c)}</MenuItem>);
	});

	return (
		<div>
			<Grid size={{xs: 12}} align={'left'}>
				<FormControl variant="outlined" size="small">
					<InputLabel>{t('locations.city')}</InputLabel>
					<Select
						value={gStorage.location.loc.tgt_id}
						onChange={locCityChanged}
						style={{width: 300, margin: 8}}>
							{cityList}
					</Select>
				</FormControl>
			</Grid>
			<Grid size={{xs: 12}} align={'left'}>
				<TextField 
					label={t('add.address')}
					value={gStorage.location.loc.address}
					onChange={action((e) => locAddrChanged(e))}
					style={{width: 300, margin: 4}} 
					variant="outlined" 
					inputProps={{maxLength: 256}}
					size="small" />
			</Grid>
		</div>
	);
});

let saving = 0;

const LocDialog = observer((props) => {
	const {isOpen, handleClose} = props;
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function locRxWs(status, msg) {
		saving = 0;

		if (status !== COMM_OK) {
			alert('Location Rx timeout!');
			return -1;
		}

		if (msg.cmd === 'location') {
			if (msg.op === 'statsave') {
				if (msg.result === 'OK') {
					handleClose(true);
				} else {
					alert('Location save failed!');
				}
			} else if (msg.op === 'statdel') {
				if (msg.result === 'OK') {
					handleClose(true);
				} else {
					alert('Location delete failed!');
				}
			} else {
				console.error('locRxWs: unknown operation:', msg.cmd, msg.op);
			}
		} else {
			console.error('locRxWs: unknown cmd', msg.cmd, msg.op);
		}
	}

	function locNameChanged(e) {
		if (!gStorage.conn.online)
			return;

		gStorage.location.loc.name = e.target.value;
		gStorage.location.modified = true;
	}

	function locTypeChanged(e) {
		if (!gStorage.conn.online)
			return;

		gStorage.location.loc.loct_id = parseInt(e.target.value, 10);
		gStorage.location.loc.tgt_id = 0;
		gStorage.location.modified = true;
	}

	function saveLoc() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'location',
			op: 'statsave',
			data: {
				location: gStorage.location.loc,
			}
		};

		saving = 1;
// 		console.log('saveLoc', msg);
		gStorage.conn.ws.send(msg, locRxWs);
	}

	function delLoc() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'location',
			op: 'statdel',
			data: {
				location: gStorage.location.loc,
			}
		};

		saving = 1;
		gStorage.conn.ws.send(msg, locRxWs);
	}

	return (
        	<Dialog onClose={() => handleClose(false)} open={isOpen ? true : false} PaperProps={{sx: {margin: 0, padding: 0}}} >
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:316}}>
				<AppBar position="sticky">
					<Toolbar variant="dense">
						<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{t('locations.location')}</Typography>
						<IconButton edge="start" color="inherit" onClick={() => handleClose(false)} aria-label="close">
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('common.name')}
						variant="outlined"
						value={gStorage.location.loc.name}
						onChange={action((e) => locNameChanged(e))}
						size="small"
						style={{width: 300, margin: 4, marginTop: 16}} 
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small" align='left'>
						<InputLabel style={{width: 300, margin: 4}}>{t('locations.type')}</InputLabel>
						<Select
							value={gStorage.location.loc.loct_id}
							onChange={action((e, type) => locTypeChanged(e, type))}
							style={{width: 300, margin: 4}}
						>
						{
							locTypes.map((lt, ind) => {
								return (<MenuItem key={lt.id} value={lt.id}>{t(lt.desc)}</MenuItem>);
							})
						}
						</Select>
					</FormControl>
				</Grid>

				<LocRegTargetField />
				<LocAssoField />
				<LocCitiesField />
				<LocAddressField />

				<Grid size={{xs: 12}} align={'center'}>
					<div>
						<Button 
							variant="contained" 
							color="primary" 
							size="small" 
							style={{width:143, margin: 4}} 
							disabled={
								!gStorage.conn.online ||
								gStorage.location.loc.id === undefined || 
								gStorage.location.loc.id === null || 
								gStorage.location.loc.user_id !== gStorage.conn.user.id || 
								gStorage.location.loc.name.length <= 0 ||
								gStorage.location.loc.loct_id <= 0 ||
								(gStorage.location.loc.loct_id === LOCT_CITY && (gStorage.location.loc.cities.length < 1 || gStorage.location.loc.cities.length > 10)) ||
								(gStorage.location.loc.loct_id === LOCT_ASSO && gStorage.location.loc.tgt_id === 0) ||
								(gStorage.location.loc.loct_id === LOCT_ADDR && (gStorage.location.loc.tgt_id === 0 || gStorage.location.loc.address.length <= 0)) ||
								(gStorage.location.loc.loct_id === LOCT_REG && gStorage.location.loc.tgt_id === 0) ||
								!gStorage.location.modified || 
								saving > 0}
							onClick={saveLoc}>
								{t('locations.save')}
						</Button>
						<Button 
							variant="contained" 
							color="primary" 
							size="small" 
							style={{width:143, margin: 4}} 
							disabled={
								!gStorage.conn.online ||
								!gStorage.location.loc.id || 
								gStorage.location.loc.user_id !== gStorage.conn.user.id || 
								saving > 0}
							onClick={delLoc}>
								{t('locations.delete')}
						</Button>
					</div>
				</Grid>
			</Grid>
		</Dialog>
	);
});

export default LocDialog;
